<template>
  <div class="flex-col pad-15">
    <!-- ONLY FOR LOADING PLACEHOLDER -->
    <div v-if="isLoading" class="content-area">
      <div v-for="i in 3" :key="i" class="item-card smooth-shadow">
        <div class="contents">
          <div class="flex-row-align-center pad-15">
            <div class="flex-col flex-expand">
              <h4 class="title fs-medium placeholder"></h4>
              <p class="caption placeholder"></p>
            </div>
          </div>
          <div class="flex-expand"></div>
          <p class="status placeholder"></p>
        </div>
      </div>
    </div>
    <!-- ACTUAL CONTENT -->
    <div
      v-else-if="getDataSources && getDataSources.length > 0"
      class="content-area"
    >
      <router-link
        v-for="dataSource in getDataSources"
        :key="dataSource.datasource_id"
        :to="`/data-sources/${dataSource.datasource_id}`"
        class="item-card smooth-shadow"
      >
        <div class="contents">
          <div class="flex-row pad-15">
            <div class="flex-col">
              <h3 class="title">{{ dataSource.datasource_name }}</h3>
              <p class="caption">
                {{ dataSource.is_ping ? "Ping Data" : "Non Ping Data" }}
              </p>
            </div>
          </div>
          <div class="flex-expand"></div>
          <div class="flex-row-align-center">
            <p class="status">{{ `${dataSource.columns.length} columns` }}</p>
            <expand />
            <i class="material-icons view-button">arrow_forward</i>
          </div>
        </div>
      </router-link>
    </div>
    <NotFound
      v-else
      :message="'No datasources found! contact your engineering team to connect datasources.'"
    />
  </div>
</template>

<script>
import { getDataSourceList } from "@/api/datasources";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("Datasources", ["getDataSources"]),
  },
  methods: {
    ...mapActions("Datasources", ["fetchDataSources"]),
  },
  mounted() {
    if (this.getDataSources.length === 0) {
      this.isLoading = true;
      // fetch the datasource list and save it in store
      this.fetchDataSources()
        .then(({ status }) => {
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.content-area {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 15px;

  @include respond-below(md) {
    grid-template-columns: 1fr;
  }

  .item-card {
    width: 100%;
    height: 150px;
    border-radius: 5px;
    background: var(--color-secondary);
    color: var(--font-color);
    transition: 0.2s all ease-in-out;

    &:hover {
      transform: scale(1.01);
    }

    .contents {
      display: flex;
      flex-direction: column;
      flex: 1;
      height: 100%;

      .card-icon {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background: var(--color-primary-light);
        margin: 10px;
      }

      .icon-text {
        padding: 10px;
        background: var(--color-primary);
        color: var(--color-secondary);
        font-size: 1.5em;
        font-weight: bold;
        margin-right: 15px;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
        display: flex;

        &.placeholder {
          background: var(--font-color-unselected);
        }
      }

      p {
        margin: 0;
      }
      h3.title {
        padding: 0 0 5px 0;
        font-weight: bold;
        overflow-wrap: break-word;
        white-space: normal;
        &.placeholder {
          background: var(--font-color-unselected);
          padding: 5px;
          width: 120px;
          border-radius: 10px;
        }
      }

      p.caption {
        opacity: 0.5;
        &.placeholder {
          background: var(--font-color-unselected);
          padding: 5px;
          width: 100px;
          margin-top: 10px;
          border-radius: 10px;
        }
      }

      .view-button {
        background: var(--color-primary-light);
        padding: 7px;
        margin: 10px;
        border-radius: 50%;
        color: var(--color-primary);
      }

      p.status {
        margin-top: auto;
        padding: 15px;

        &.placeholder {
          background: var(--font-color-unselected);
          padding: 5px;
          width: 130px;
          margin: 15px;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
